export const EDUCATOR_ROLE = 'educator';
export const STUDENT_ROLE = 'student';
export const STAFF_ROLE = 'staff';

export type UserSpaceRole =
  | typeof EDUCATOR_ROLE
  | typeof STUDENT_ROLE
  | typeof STAFF_ROLE;
